import React from "react";

const Switch = ({
  label,
  value,
  onChange,
  subtext = null
}) => (
  <>
    <div className="question-container">
      <label className="question" htmlFor={label}>
        {label}
      </label>
      <label className="switch" htmlFor={label}>
        <input
          type="checkbox"
          id={label}
          checked={value}
          onChange={() => onChange(!value)}
        />
        <span className="slider round" />
      </label>
      {subtext && <small style={{ display: 'block', marginTop: '1rem', lineHeight: 1.5 }}>
        {typeof subtext === "string" && subtext}
        {typeof subtext === "function" && subtext()}
      </small>}
    </div>
  </>
);

export default Switch;
